import React from 'react';
import AbstractRequestTask from './AbstractRequestTask';

class ValidateCaptchaCartTask extends AbstractRequestTask {

  constructor(config, region, params) {
    super();
    this.config = config;
    this.region = region;
    this.params = params;
  }

  getUrl() {
    return `https://www.clarovideo.com/${this.region}/vcard/tofriendcaptcha`;
  }

  getParams() {
    let params = {}; // super.getParams(this.config);
    this.params = Object.assign(params, this.params);

    return this.params;
  }

  success(data, b) {
    this.resolve(data);
  }

  getMethod() {
    return 'POST';
  }
}

export default ValidateCaptchaCartTask;